@if (details$ | async; as details) {
  <div class="grid grid-cols-2 gap-3">
    <div class="col-span-2">
      <app-details-view label="Zdjęcie główne">
        @if (isNotNil(details.featuredFile)) {
          <app-multimedia-galleria-thumbnails
            [files]="[details.featuredFile]"
            [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
        }
      </app-details-view>
    </div>

    <app-details-view label="Identyfikator">
      @if (isNotNil(details.id)) {
        {{ details.id }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Nazwa">
      @if (isNotNil(details.name)) {
        {{ details.name }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Marka kosmetyczna">
      @if (isNotNil(details.cosmeticBrandName)) {
        {{ details.cosmeticBrandName }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Odpowiednik magazynowy">
      @if (isNotNil(details.warehouseProductName)) {
        {{ details.warehouseProductName }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Data utworzenia">
      @if (isNotNil(details.createdAt)) {
        <app-date [date]="details.createdAt" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Cena">
      @if (isNotNil(details.price)) {
        <app-currency [amount]="details.price" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Dostępna ilość do kupienia">
      @if (isNotNil(details.availableQuantity)) {
        {{ details.availableQuantity }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Maksymalna ilość sztuk w zamówieniu">
      @if (isNotNil(details.maxQuantityPerOrder)) {
        {{ details.maxQuantityPerOrder }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Status">
      @if (isNotNil(details.status)) {
        <app-admin-product-status [status]="details.status" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Hasło">
      @if (isNotNil(details.password)) {
        {{ details.password }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Slug">
      @if (isNotNil(details.slug)) {
        {{ details.slug }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Produkt wirtualny">
      @if (isNotNil(details.virtual)) {
        {{ details.virtual | boolean }}
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <app-details-view label="Adres URL do produktu w sklepie">
      @if (isNotNil(details.shopPreviewUrl)) {
        <app-admin-product-link
          [status]="details.status"
          [slug]="details.slug" />
      } @else {
        <app-no-data />
      }
    </app-details-view>

    <div class="col-span-2">
      <app-details-view label="Atrybuty produktu">
        @if (shouldShowAttributesAccordions(details.attributes)) {
          <div class="rounded-lg border border-gray-200 p-4">
            <p-accordion [multiple]="true">
              @for (
                attribute of details.attributes;
                track attribute.id;
                let index = $index
              ) {
                <p-accordion-panel [value]="index">
                  <p-accordion-header>
                    <div class="flex items-center gap-2 text-sm text-gray-400">
                      <span>#{{ index + 1 }}</span>
                      <span>{{ attribute.label }}</span>
                    </div>
                  </p-accordion-header>

                  <p-accordion-content>
                    <p-accordion-content>
                      <app-summernote-html-preview [html]="attribute.content" />
                    </p-accordion-content>
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>

    <div class="col-span-2">
      <app-details-view label="Charakterystyka produktu">
        @if (shouldShowCharacteristicsAccordions(details.characteristics)) {
          <div class="rounded-lg border border-gray-200 p-4">
            <p-accordion [multiple]="true">
              @for (
                characteristic of details.characteristics;
                track characteristic.id;
                let index = $index
              ) {
                <p-accordion-panel [value]="index">
                  <p-accordion-header>
                    <div class="flex items-center gap-2 text-sm text-gray-400">
                      <span>#{{ index + 1 }}</span>
                      <span>{{ characteristic.label }}</span>
                    </div>
                  </p-accordion-header>

                  <p-accordion-content>
                    <app-summernote-html-preview
                      [html]="characteristic.content" />
                  </p-accordion-content>
                </p-accordion-panel>
              }
            </p-accordion>
          </div>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>

    <app-details-view label="Galeria">
      <app-multimedia-galleria-thumbnails
        [files]="details.files"
        [fetchMultimediaDetailsFn]="fetchMultimediaDetailsFn" />
    </app-details-view>
  </div>
} @else {
  <app-spinner-filled />
}
